<div class="modal" [ngClass]="{ 'open': isOpen }">
  <p-toast></p-toast>
  <div class="modal-container">
    <h2 class="modal-title">{{'negociacao_produtos' | transloco}}
      <button type="button" class="close" aria-label="Fechar" (click)="closeModal()">
        <span aria-hidden="true">×</span>
      </button>
    </h2>
    <div class="modal-content">

      <div class="processing-state" *ngIf="uploading">
        <mat-spinner diameter="48"></mat-spinner>
        <p>{{ 'lista_compras_processando' | transloco }}</p>
      </div>

      <div class="processing-state processing-error" *ngIf="!uploading && uploadError">
        <p>{{ uploadError | transloco }}</p>
        <app-botao texto="{{'fechar' | transloco}}" classe="btn-link text-uppercase" (clique)="closeModal()">
        </app-botao>
      </div>

      <mat-horizontal-stepper [linear]="true" #negociacaoStepper *ngIf="!uploading && !uploadError">
        <mat-step *ngIf="!usuarioEstaLogado">
          <app-registro-cliente *ngIf="!usuarioJaTemUmaConta" subtitulo="{{'antes_iniciar_conhecer' | transloco}}"
            (registroFinalizado)="registroFinalizado($event)">
          </app-registro-cliente>
          <app-acesso-cliente *ngIf="usuarioJaTemUmaConta" subtitulo="{{'antes_iniciar_acesso' | transloco}}"
            (acessoFinalizado)="acessoFinalizado($event)">
          </app-acesso-cliente>
        </mat-step>
        <mat-step [stepControl]="negociacaoFormGroup">
          <form [formGroup]="negociacaoFormGroup">
            <div class="products-list" formArrayName="products">
              <div *ngFor="let productGroup of productFormArray?.controls; let i=index" [formGroupName]="i"
                class="product-row">
                <div class="row align-items-center">
                  <div class="col-md-12">
                    <h4>{{ productGroup?.get?.("nome")?.value }}</h4>
                    <span class="badge-sem-correspondencia" *ngIf="isBulkFlow && productCandidates[i]?.length === 0">
                      {{ 'sem_correspondencia_catalogo' | transloco }}
                    </span>
                  </div>
                  <div class="col-md-2">
                    <img [src]="productGroup?.get?.('imagemUrl')?.value"
                      alt="{{productFormArray?.controls?.[i]?.get?.('ean')?.value || 'Produto'}}" class="product-image">
                    <app-produto-candidato-selector
                      *ngIf="isBulkFlow && productCandidates[i]?.length > 1"
                      [candidatos]="productCandidates[i]"
                      [selectedEan]="productGroup?.get?.('ean')?.value"
                      (selecionado)="selecionarCandidato(i, $event)">
                    </app-produto-candidato-selector>
                  </div>
                  <div class="col-md-10">
                    <div class="row">
                      <div class="col-xl-6">
                        <app-lista [opcoes]="duracoes" [formulario]="getProductFormGroup(i)" nomeControle="duracao"
                          descricao="{{'duracao_negociacao' | transloco}}" classe="horizontal-100">
                        </app-lista>
                      </div>
                      <div class="col-xl-6">
                        <app-campo [formulario]="getProductFormGroup(i)" nomeControle="quantidade"
                          descricao="{{'quantidade_simples' | transloco}}" classe="horizontal-100">
                        </app-campo>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-6">
                        <app-campo-dinheiro [formulario]="getProductFormGroup(i)" nomeControle="valor_pretendido"
                          descricao="{{'valor_pretendido_unidade' | transloco}}"
                          textoAjuda="{{'valor_pretendido_opcional' | transloco}}" classe="horizontal-100">
                        </app-campo-dinheiro>
                      </div>
                      <div class="col-xl-6">
                        <mat-checkbox class="pt-3" formControlName="encerrar_automaticamente">{{'finalizar_lance_igual'
                          | transloco}}</mat-checkbox>
                      </div>
                    </div>
                    <div class="row justify-content-end">
                      <div class="col-xl-10">
                        <h5 class="text-muted">{{'condicao_produto' | transloco}}</h5>
                        <mat-radio-group aria-label="Select an option" formControlName="condicao">
                          <mat-radio-button *ngFor="let condicao of condicoesProdutos"
                            [value]="condicao.codigo">{{condicao.codigo | transloco}}</mat-radio-button>
                        </mat-radio-group>
                      </div>
                      <div class="col-xl-2">
                        <div class="row mt-2">
                          <div class="col-12">
                            <app-botao texto="{{'excluir' | transloco}} &nbsp;" classe="btn btn-danger"
                              posicaoDoIcone="direita" icone="fas fa-trash" (clique)="removeProduct(i)">
                              <!-- [executando]="productGroup" -->

                            </app-botao>
                            <!-- <button mat-raised-button type="button" color="danger" (click)="removeProduct(i)">Remover produto</button> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="line-letter"></div>
                </div>
              </div>
            </div>
            <div class="row pt-4">
              <div class="col-xl-6">
                <app-botao texto="{{'iniciar_negociacoes' | transloco}}" [executando]="loading"
                  classe="btn-primary horizontal-100" posicaoDoIcone="direita" (clique)="iniciaNegociacao()">
                </app-botao>
                <p class="progresso-criacao-lote" *ngIf="loading && criacaoProgresso">
                  {{ 'criando_negociacoes_lote' | transloco:{ atual: criacaoProgresso.concluido, total: criacaoProgresso.total } }}
                </p>
              </div>
              <div class="col-xl-6 order-xl-first">
                <app-botao texto="{{ 'cancelar' | transloco }}" [desabilitado]="loading"
                  classe="btn-link text-uppercase order-sm-last horizontal-100" (clique)="closeModal()">
                </app-botao>
              </div>
            </div>
          </form>
        </mat-step>
        <mat-step>
          <!-- Bug encontrado em QA (E-42): com falha total (0 sucessos), o
               header dizia "Tudo certo!" — enganoso para um lote que falhou
               por completo. Título condicional só quando há resumo. -->
          <h3><strong class="text-inversu">{{ (criacaoResumo && criacaoResumo.sucesso === 0 && criacaoResumo.total > 0 ? 'negociacoes_nao_criadas' : 'tudo_certo') | transloco}}</strong></h3>
          <ng-container *ngIf="criacaoResumo; else mensagemPadraoFinalizacao">
            <p>{{ 'resumo_negociacoes_criadas' | transloco:{ sucesso: criacaoResumo.sucesso, total: criacaoResumo.total } }}</p>
            <ng-container *ngIf="criacaoResumo.falhas > 0">
              <p class="resumo-falhas">{{ 'resumo_negociacoes_falha' | transloco:{ falhas: criacaoResumo.falhas } }}</p>
              <ul class="lista-falhas">
                <li *ngFor="let itemComFalha of criacaoResumo.itensComFalha">{{ itemComFalha.nome }}</li>
              </ul>
            </ng-container>
          </ng-container>
          <ng-template #mensagemPadraoFinalizacao>
            <p>{{'aguardar_ofertas' | transloco}}</p>
          </ng-template>

          <div class="salvar-favoritos-card" *ngIf="mostrarSalvarFavoritos">
            <div class="salvar-favoritos-cabecalho">
              <img src="assets/images/icons/heart_smile.svg" alt="" width="28" height="28">
              <h5>{{ 'salvar_favoritos_titulo' | transloco }}</h5>
            </div>
            <p class="salvar-favoritos-descricao">{{ 'salvar_favoritos_descricao' | transloco }}</p>
            <input type="text" class="form-control" [(ngModel)]="nomeFavoritos" [disabled]="salvandoFavoritos"
              placeholder="{{ 'salvar_favoritos_nome_placeholder' | transloco }}" maxlength="60" name="nomeFavoritos">
            <div class="row pt-3">
              <div class="col-xl-6">
                <app-botao texto="{{ 'salvar_favoritos_botao_salvar' | transloco }}" [executando]="salvandoFavoritos"
                  [desabilitado]="!nomeFavoritos?.trim()" classe="btn-primary horizontal-100"
                  (clique)="salvarComoFavoritos()">
                </app-botao>
              </div>
              <div class="col-xl-6 order-xl-first">
                <app-botao texto="{{ 'salvar_favoritos_botao_pular' | transloco }}" [desabilitado]="salvandoFavoritos"
                  classe="btn-link text-uppercase horizontal-100" (clique)="dispensarSalvarFavoritos()">
                </app-botao>
              </div>
            </div>
          </div>

          <div class="tornar-recorrente-card" *ngIf="mostrarTornarRecorrente && !mostrarSalvarFavoritos">
            <div class="tornar-recorrente-cabecalho">
              <span class="tornar-recorrente-icone">
                <img src="assets/images/icons/recurring-purchase.svg" alt="" width="18" height="18">
              </span>
              <h5>{{ 'compra_rotina_card_titulo' | transloco }}</h5>
            </div>
            <p class="tornar-recorrente-descricao">{{ 'compra_rotina_card_descricao' | transloco }}</p>
            <div class="row pt-1">
              <div class="col-xl-6">
                <app-botao texto="{{ 'compra_rotina_card_botao_configurar' | transloco }}"
                  classe="btn-primary horizontal-100" (clique)="abrirTornarRecorrente()">
                </app-botao>
              </div>
              <div class="col-xl-6 order-xl-first">
                <app-botao texto="{{ 'compra_rotina_card_botao_pular' | transloco }}"
                  classe="btn-link text-uppercase horizontal-100" (clique)="dispensarTornarRecorrente()">
                </app-botao>
              </div>
            </div>
          </div>

          <div class="row pt-4">
            <div class="col-xl-6">
              <app-botao texto="{{'ver_negociacoes' | transloco}}" [executando]="loading"
                classe="btn-primary horizontal-100" posicaoDoIcone="direita"
                icone="fa-solid fa-arrow-up-right-from-square" (clique)="irParaNegociacao()">
              </app-botao>
            </div>
            <div class="col-xl-6 order-xl-first">
              <app-botao texto="{{'ok_entendi' | transloco}} =)" [desabilitado]="loading"
                classe="btn-link text-uppercase horizontal-100" (clique)="closeModal()">
              </app-botao>
            </div>
          </div>
        </mat-step>
        <!-- 4º passo (E-44/T-271): "Configurar recorrência" do card acima
             leva até aqui em vez de abrir um MatDialog por cima deste — era
             o diálogo aninhado que a T-270 flagrou (dois focus-trap
             encadeados). Mesmo `*ngIf` do card-teaser: só existe quando a
             origem é bulk-list-import (tem `prompt_id`). -->
        <mat-step *ngIf="mostrarTornarRecorrente">
          <app-tornar-recorrente-form
            [itens]="itensParaRecorrencia"
            modo="parametrizado"
            [origem]="origemRecorrente"
            (salvo)="closeModal()"
            (cancelado)="closeModal()">
          </app-tornar-recorrente-form>
        </mat-step>
      </mat-horizontal-stepper>
    </div>
  </div>
</div>
